export default __webpack_public_path__ + "static/slider-asiento-gym-53650d482e838550e333689276679257.png";